import { createApi } from '@reduxjs/toolkit/query/react';
import { fileUploadBaseQueryWithReauth } from './utils';

const INVOICE_WINNER_NOTIFIER_URL = '/invoices';

export const invoiceNotifierApi = createApi({
    reducerPath: 'invoiceNotifierApi',
    baseQuery: fileUploadBaseQueryWithReauth,
    endpoints: builder => ({
        createInvoiceNotifier: builder.mutation({
            query: ({ file }) => {
                const formData = new FormData();
                formData.append('file', file);
                return {
                    url: `${INVOICE_WINNER_NOTIFIER_URL}/winning/notifications`,
                    method: 'POST',
                    body: formData,
                };
            },
        }),
    }),
});

export const {
    useCreateInvoiceNotifierMutation,
} = invoiceNotifierApi;
